import styled from 'styled-components';

// The buttons on the Learn exercise screens (issue #3473), from the "Rhythm Echo (result)" and
// "Session summary" artboards: full width, 52 px, radius 10, 17 px Jost-SemiBold; the primary
// filled in the accent colour, the secondary outlined in it, and a text button for the quiet
// actions (Stop, Recalibrate). The onboarding Button is the app's other full-width button, but its
// raised drop-shadow look belongs to onboarding; the exercises use the flat pair the canvas draws.

export const learnButtonHeight = 52;

const buttonStyles = `
  box-sizing: border-box;
  width: 100%;
  height: ${learnButtonHeight}px;
  padding: 0 16px;
  border-radius: 10px;
  font-family: Jost-SemiBold, Arial, sans-serif;
  font-size: 17px;
  line-height: 1;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

// The two looks the pair is: filled in the accent colour, or outlined in it
const solidColors = `
  background-color: var(--color-tab-selected);
  color: var(--color-background);

  &:active:not(:disabled) {
    filter: brightness(0.9);
  }
`;

const outlinedColors = `
  background-color: transparent;
  color: var(--color-tab-selected);

  &:active:not(:disabled) {
    background-color: color-mix(in srgb, var(--color-tab-selected) 12%, transparent);
  }
`;

export const PrimaryButton = styled.button`
  ${buttonStyles}
  border: 2px solid var(--color-tab-selected);
  ${solidColors}
`;

export const SecondaryButton = styled.button`
  ${buttonStyles}
  border: 2px solid var(--color-tab-selected);
  ${outlinedColors}
`;

// One button that changes its mind without changing its identity: outlined until `$solid`, filled
// after it. A screen that swapped SecondaryButton for PrimaryButton instead would be swapping one
// element for another, and React would remount it - dropping the focus on it and any press already
// under a finger, exactly while the singer is reaching for it (issue #3518).
export const ToggleButton = styled.button<{ $solid: boolean }>`
  ${buttonStyles}
  border: 2px solid var(--color-tab-selected);
  ${({ $solid }) => ($solid ? solidColors : outlinedColors)}
`;

export const TextButton = styled.button`
  padding: 8px 12px;
  border: none;
  background: none;
  font-family: Jost-SemiBold, Arial, sans-serif;
  font-size: 15px;
  line-height: 1;
  color: var(--color-tab-selected);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

// Between the two buttons of a column, and what a screen that reserves their height has to add
export const buttonColumnGap = 14;

// Stacks the primary over the secondary at the foot of a screen
export const ButtonColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${buttonColumnGap}px;
`;
